import React, { FC } from 'react';
import { RoomTyper } from 'store/services/typingPresence';
import Styles from './TypingLabel.module.scss';

interface TypingLabelProps {
  typers: RoomTyper[];
  className?: string;
  /** Host can pass --composer-height for phone fixed positioning. */
  style?: React.CSSProperties;
}

const Name: FC<{ children: string }> = ({ children }) => (
  <span className={Styles.name}>{children}</span>
);

/** Idle: no layout space. Active: in-flow band (desktop) or fixed above composer (phone). */
const TypingLabel: FC<TypingLabelProps> = ({ typers, className, style }) => {
  const extra = className ? ` ${className}` : '';

  if (typers.length === 0) {
    return (
      <div
        className={`${Styles.typingIdle}${extra}`}
        style={style}
        aria-hidden="true"
      />
    );
  }

  let content: React.ReactNode;
  if (typers.length === 1) {
    content = (
      <>
        <Name>{typers[0].name}</Name> is typing…
      </>
    );
  } else if (typers.length === 2) {
    content = (
      <>
        <Name>{typers[0].name}</Name> and <Name>{typers[1].name}</Name> are typing…
      </>
    );
  } else {
    content = (
      <>
        <Name>{typers[0].name}</Name> and {typers.length - 1} others are typing…
      </>
    );
  }

  return (
    <div className={`${Styles.typingActive}${extra}`} style={style} aria-live="polite">
      <div className={Styles.typingText}>{content}</div>
    </div>
  );
};

export default TypingLabel;
